export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '专属卡片';